/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Jan 2023
 * @flow
 */

import React, { useState, useEffect } from 'react';
import Body from '../../components/Body';
import Popup from '../../../../components/Popup/Popup';
import PopupContent from '../../../../components/Popup/PopupContent';
import classes from './Desktop.module.css';
import { TmsComponents as TmsEnums } from '../../../../enums';
import BookingActions from '../../components/BookingActions';
import TableActions from '../../components/TableActions';
import CreateBooking from '../../components/CreateBooking';
import UpdateBooking from '../../components/UpdateBooking';
import TableLookup from '../../components/TableLookup';
import EventEmitter from "../../../../util/event-emitter";
import EmployeeLookup from "../../components/EmployeeLookup";
import MergeTableLookup from '../../components/MergeTableLookup';
import SensorSelection from '../../../Fireboard/components/SensorSelection';
import About from '../../../Fireboard/components/About';
import CheckDetails from '../../components/CheckDetails';
import FireboardSmsComponent from '../../../Fireboard/components/SmsComponent';
import HelpPopup from '../../components/HelpPopup';
import CheckSelection from '../../components/CheckSelection';

export default function Desktop(props) {
  const {
    popup,
    onClosePopup,
    onBookingActionClick,
    onCreateBooking,
    onUpdateBooking,
    selectedBooking,
    shapes,
    onEmployeeSelection,
    showEmployeeList,
    employees,
    onMergeTable,
    seatWithoutTableSelection,
    navigateToSensor,
    onMoveTable,
    selectedItem,
    onHandleSend,
    storeInfo,
    isCustomSmsType,
    customSmsList,
    onChangeSmsType,
    iso2,
    currency,
    selectedShape,
    onTableActionClick,
  } = props;

  const [keyboardHeight, setKeyboardHeight] = useState(0);

  useEffect(() => {
    var listener;
    if (window.ReactNativeWebView && EventEmitter.getOS() === 'Android') {
      listener = height => setKeyboardHeight(height);
      EventEmitter.addListeners('keyboard', listener);
    }

    return () => {
      listener && EventEmitter.removeListeners('keyboard', listener);
    };
  }, []);

  const getPopupContent = () => {
    if (!popup) return;
    switch (popup.type) {
      case TmsEnums.tmsBookingActions: {
        return (
          <BookingActions
            selectedBooking={selectedBooking}
            onClosePopup={onClosePopup}
            onBookingActionClick={onBookingActionClick}
          />
        );
      }
      case TmsEnums.tmsSms: {
        return (
          <FireboardSmsComponent
            selectedItem={selectedItem}
            onHandleSend={onHandleSend}
            storeInfo={storeInfo}
            onClose={onClosePopup}
            iso2={iso2}
            currency={currency}
            isCustomSmsType={isCustomSmsType}
            customSmsList={customSmsList}
            onChangeSmsType={onChangeSmsType}
          />
        );
      }
      case TmsEnums.tmsCreateBooking: {
        return (
          <CreateBooking
            onClosePopup={onClosePopup}
            onCreateBooking={onCreateBooking}
          />
        );
      }
      case TmsEnums.tmsUpdateBooking: {
        return (
          <UpdateBooking
            booking={selectedBooking}
            onClosePopup={onClosePopup}
            onUpdateBooking={onUpdateBooking}
          />
        );
      }
      case TmsEnums.tmsTableLookup: {
        return (
          <TableLookup
            onClosePopup={onClosePopup}
            shapes={shapes}
            showEmployeeList={showEmployeeList}
            seatWithoutTableSelection={seatWithoutTableSelection}
          />
        );
      }
      case TmsEnums.employeeSelection: {
        return (
          <EmployeeLookup
            onEmployeeSelection={onEmployeeSelection}
            employees={employees}
            onClosePopup={onClosePopup}
          />
        );
      }
      case TmsEnums.mergeTableLookup: {
        return (
          <MergeTableLookup
            onClosePopup={onClosePopup}
            shapes={shapes}
            onMergeTable={onMergeTable}
            selectedShape={popup?.metaData?.selectedShape}
            selectedCheck={popup?.metaData?.selectedCheck}
            onMoveTable={onMoveTable}
          />
        );
      }
      case TmsEnums.tmsSensors:
        return (
          <SensorSelection
            navigateToSensor={navigateToSensor}
            dismissPopup={onClosePopup}
          />
        );
      case TmsEnums.tmsAbout:
        return <About onClose={onClosePopup} />;
      case TmsEnums.helpPopup:
        return <HelpPopup onClose={onClosePopup} headerFlow={popup.meta.fromHeader} />
      case TmsEnums.tmsCheckSelectionPopup:
        return (
          <CheckSelection
            onClosePopup={onClosePopup}
            data={popup.metaData}
          />
        );
      case TmsEnums.showTableMenu:
        return (
          <TableActions
            selectedItem={selectedItem}
            selectedShape={selectedShape}
            onClosePopup={onClosePopup}
            onTableActionClick={onTableActionClick}
          />
        );
      default: {
        return <PopupContent {...popup} />;
      }
    }
  };

  const getPopupStyle = () => {
    let popupStyle = { width: '31.25vw' };
    if (popup && popup.type === 'spinner') {
      popupStyle = { width: '50%' };
    } else if (popup && popup.type === TmsEnums.tmsBookingActions) {
      popupStyle = { width: '25%' };
    } else if (popup && popup.type === TmsEnums.tmsCreateBooking) {
      popupStyle = { width: '25%' };
    } else if (popup && popup.type === TmsEnums.tmsUpdateBooking) {
      popupStyle = { width: '25%' };
    } else if (popup && (popup.type === TmsEnums.tmsTableLookup || popup.type === TmsEnums.mergeTableLookup)) {
      popupStyle = { width: '70vw', height: '100vh' };
    } else if (popup && popup.type === TmsEnums.tmsSensors) {
      popupStyle = { width: '35%' };
    } else if (popup && popup.type === TmsEnums.tmsAbout) {
      popupStyle = { width: "34vw" };
    } else if (popup && popup.type === TmsEnums.tmsSms) {
      popupStyle = { height: "90vh", width: "70vw" };
    } else if (popup && popup.type === TmsEnums.helpPopup) {
      popupStyle = { width: '40%' };
    } else if (popup && popup.type === TmsEnums.showTableMenu) {
      popupStyle = { width: '20%' };
    } else if (popup && popup.type === TmsEnums.tmsCheckSelectionPopup) {
      popupStyle = { width: '70%' };
    }
    return popupStyle;
  };

  return (
    <div className={classes.container} style={{ paddingBottom: keyboardHeight }}>
      <Popup visible={!!popup} popupStyle={getPopupStyle()}>
        {getPopupContent()}
      </Popup>
      <Body {...props} />
      <CheckDetails {...props} />
    </div>
  );
}
